<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5>Manage Online Exams</h5>
        </div>
        <div class="col-6 col-sm-4 text-right">
          <a-tooltip
              placement="top"
              title="Add online exam"
            >
          <button v-if="pagepermission.insertable"
            type="button"
            class="btn btn-primary btn-with-addon"
            @click="showFormModal"
          >
            <span class="btn-addon">
              <i class="btn-addon-icon fe fe-plus-circle" />
            </span>
            Online Exam
          </button>
          </a-tooltip>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-if="pagepermission.viewable">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
              <div v-show="hidden">
                <!-- need to load neo-ckeditor to render MathML type code  -->
                <!-- so here a hidden neo-ckeditor is pre declare to render question priview MathML data -->
                <neo-ckeditor :initialValue= undefined v-show="hidden"></neo-ckeditor>
              </div>
            <online-exams-table :rolesetting="pagepermission" :data="data" :loading="loading" @updateTable="handleUpdateTable" />
          </div>
        </div>
        <div class="text-right">
          <a-pagination
              showSizeChanger
              @showSizeChange="onShowSizeChange"
              :total="meta.total"
              :pageSize.sync="pageSize"
              v-model="current"
              @change="onChange"
            >
          </a-pagination>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-else>
      <p class="error">
        You don't have permission to use this feature.
      </p>
    </div>

    <online-exam-form @saved="handleSaved"/>
  </div>
</template>

<script>
import NeoCkeditor from '@/components/ckeditor'
import OnlineExamsTable from '@/components/online-exam/exam/Table/index'
import OnlineExamForm from '@/components/online-exam/exam/Forms/index'

export default {
  components: {
    OnlineExamsTable,
    OnlineExamForm,
    NeoCkeditor,
  },
  beforeMount: function() {
    let rc = this.$roleutility.checkpermission('online-exam', 22)
    rc.then(data => {
      console.log('RoleCheck!Data processed. ', data)
      this.pagepermission = data.pagePermission
    })
  },
  mounted: function() {
    this.getOnlineExams()
  },
  data: function() {
    return {
      loading: false,
      visible: false,
      data: [],
      meta: {},
      current: 1,
      pageSize: 30,
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
      },
    }
  },
  methods: {
    showFormModal: function() {
      this.$eventBus.$emit('openOnlineExamFormModal')
    },
    getOnlineExams: function() {
      this.loading = true
      this.$http.get('/api/online-exam/all', {
        params: {
          limit: this.pageSize,
          page: this.current,
        },
      }).then(({ data }) => {
        this.loading = false
        this.data = data.data
        this.meta = data.meta
      })
    },
    handleSaved: function() {
      this.getOnlineExams()
    },
    handleUpdateTable: function() {
      this.getOnlineExams()
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getOnlineExams()
    },
    onChange(current) {
      this.current = current
      this.getOnlineExams()
    },
  },
}
</script>
<style>
.error { padding: 25px; }
</style>
